import { Printer } from "lucide-react";

// PATCH 36 Me12 — print/PDF a specific on-brand document. The target element must carry the
// class `k-print-doc`; the print stylesheet in index.css hides all app chrome around it.
export default function PrintButton({ label = "Print", testid = "print-button" }) {
  return (
    <button className="k-btn k-btn-ghost k-no-print" data-testid={testid} onClick={() => window.print()}
      style={{ padding: "8px 14px", fontSize: 13 }}>
      <Printer size={14} /> {label}
    </button>
  );
}
